import {Component, Input, OnInit} from '@angular/core';
import {CTWorkOrder} from "../../../../../../_core/classes/ct-work-order";
import {CtWorkOrderInformationContent} from "../../../../../../_core/classes/ct-work-order.information-content";
import {CTWorkOrderRowUnionType} from "../../../../../../_core/classes/ct-work-order.row-union";
import {WorkOrderService} from "../../../../work-order.service";
import {MovementManagerConfiguration} from "../movement-manager.configuration";
import {MovementManagerAddItemService} from "../movement-manager-add-item/movement-manager-add-item.service";
import {WorkOrderRowState} from "../../../../../../_core/enum/work-order-row-state";
import {CtButtonConfiguration, FormatConfigService, MAT_RAISED_PRIMARY} from "@ctsolution/ct-framework";
import {ModuleCreateService} from "../../../../../catalog/catalog-detail/module-create/module-create.service";
import {OriginCreateWorkOrderEnum, TransferItemsRequestParameter} from "../../../../../../_core/classes/transfer-items-request-parameter";
import {Table} from "primeng/table";
import { CTConfigurationModel } from 'projects/ct-manager/src/app/_core/classes/ct-configuration-model';
import { CtManagerService } from 'projects/ct-manager/src/app/_core/lib/ct-manager.service';
import { MatLegacyDialog } from '@angular/material/legacy-dialog';
import { MovementManagerDescriptionDialogComponent } from '../movement-manager-description-dialog/movement-manager-description-dialog.component';

@Component({
  selector: 'app-movement-manager-rows',
  templateUrl: './movement-manager-rows.component.html',
  styleUrls: ['./movement-manager-rows.component.scss'],
  providers: [ModuleCreateService]
})
export class MovementManagerRowsComponent implements OnInit {

  items: Array<CTWorkOrderRowUnionType> = new Array<CTWorkOrderRowUnionType>();
  @Input() configuration: MovementManagerConfiguration | null = null;

  colsWorkOrderRowsConfiguration : CTConfigurationModel = CTConfigurationModel.create();

  createButton: CtButtonConfiguration = CtButtonConfiguration
    .create()
    .setLabel("generateMovementsLabel")
    .setAction(() => this.createOrders())
    .setMatherialOptions(MAT_RAISED_PRIMARY)
    .setDisabled(true);

  createButtonTooltip: string = "Selezionare almeno un articolo per generare una movimentazione";

  filterPanelEnabled: boolean = false;

  // Tutte le colonne disponibili per la tabella
  private readonly allCols = [
    {field: 'Code', header: 'ItemCode'},
    {field: 'Description', header: 'ItemDescription'},
    {field: 'Type', header:'Type'},
    {field: 'Quantity', header: 'Quantity'},
    {field: 'Amount', header: 'AmountRow'},
    {field: 'Discount', header: 'Sconto'},
    {field: 'VAT', header: 'IVA'},
    {field: 'Total', header: 'Totale'}
  ]

  // Colonne di default (senza Discount)
  private readonly defaultCols: string[] = ['Code', 'Description', 'Type', 'Quantity', 'Amount', 'VAT', 'Total'];

  // Colonne effettivamente visualizzate (filtrate in base alla configurazione)
  cols = [...this.allCols];

  selectedItems: any[] = [];

  get isCreateButtonVisible() {
    return this.items.filter(elm => elm.State !== WorkOrderRowState.Closed).length > 0
      && !this.configuration?.IsQuotation
      && this.colsWorkOrderRowsConfiguration.multiCheckBoxTable;
  }

  constructor(
    private workOrderService: WorkOrderService,
    private moduleCreateService: ModuleCreateService,
    private movementManagerAddItemService: MovementManagerAddItemService,
    private managerService : CtManagerService,
    private formatConfigService : FormatConfigService,
    private dialog: MatLegacyDialog) {}

  async ngOnInit(): Promise<void> {

    const formatConfiguration: CTConfigurationModel = CTConfigurationModel.create();

    await this.managerService.getComponentOverride("formatDigits", "formatConfiguration", formatConfiguration).then((component) => {
      return;
    });

    this.formatConfigService.setDefaultPriceDigits(formatConfiguration.formatPrice);
    this.formatConfigService.setDefaultNumberDigits(formatConfiguration.formatNumber);

  }

  isRowDisabled(item: any): boolean {
    if (item.State === WorkOrderRowState.Closed || !!this.configuration?.IsQuotation) {
      return true;
    }

    const isManualRow = !item.Item && !item.Offer && !item.Contact;

    return isManualRow;
  }

  getSelectedOids(): number[] {
    return this.selectedItems.map(item => item.Oid);
  }

  isAllSelectableChecked(): boolean {

    const selectableItems = this.items.filter(item => !this.isRowDisabled(item));

    if (selectableItems.length === 0) {
      return false;
    }

    return selectableItems.every(item =>
      this.selectedItems.some(selected => selected.Oid === item.Oid)
    );
  }

  toggleAllSelectable(event: any): void {
    const selectableItems = this.items.filter(item => !this.isRowDisabled(item));

    if (event.checked) {
      this.selectedItems = [...selectableItems];
    } else {
      this.selectedItems = [];
    }

    this.updateCreateButtonState();
  }

  hasSelectableItems(): boolean {
    return this.items.some(item => !this.isRowDisabled(item));
  }

  onSelectionChange(selection: any[]): void {
    if (this.colsWorkOrderRowsConfiguration.multiCheckBoxTable) {
      this.selectedItems = selection.filter(item => !this.isRowDisabled(item));
    } else {
      this.selectedItems = [];
    }

    this.updateCreateButtonState();
  }

  addItem(value: CTWorkOrderRowUnionType) {
    this.items = [...this.items, value];
  }

  toggleFilters(table: Table) {

    this.filterPanelEnabled = !this.filterPanelEnabled;

    if (!this.filterPanelEnabled) {
      table.clear();
    }

  }

  async onRowEdit(idx: number, row: CTWorkOrderRowUnionType) {

    const item = await this.movementManagerAddItemService.manageRow(this.configuration, row);

    if (item) this.items[idx] = item;

  }

  /**
   * Gestisce la clonazione di una riga esistente
   * Crea una copia della riga (senza Oid per indicare che è nuova),
   * apre la modale per modificare Quantità e Prezzo,
   * e aggiunge la nuova riga solo se l'utente conferma
   * 
   * @param row Riga da clonare
   */
  async onRowClone(row: CTWorkOrderRowUnionType) {

    // Crea una copia della riga rimuovendo l'Oid per indicare che è una nuova riga
    // Questo fa sì che il salvataggio crei un nuovo record invece di aggiornare quello esistente
    const clonedRow: any = {
      ...row,
      Oid: undefined, // Rimuovo l'Oid per forzare la creazione di una nuova riga
      RowNumber: undefined, // Rimuovo anche il numero riga, verrà assegnato dal backend
      CreateAt: undefined, // Rimuovo le date, verranno assegnate dal backend
      UpdateAt: undefined
    };

    // Apro la modale di modifica passando la riga clonata
    // L'utente potrà modificare Quantità e Prezzo
    const item = await this.movementManagerAddItemService.manageRow(this.configuration, clonedRow);

    // Se l'utente conferma (item !== null), aggiungo la nuova riga alla tabella
    if (item) {
      this.items = [...this.items, item];
    }

  }

  onRowDelete(idx: number, row: CTWorkOrderRowUnionType) {

    const splice = () => {

      this.items.splice(idx, 1);
      this.items = [...this.items];

      const selectedIndex = this.selectedItems.findIndex(item => item.Oid === row.Oid);
      if (selectedIndex > -1) {
        this.selectedItems.splice(selectedIndex, 1);
        this.updateCreateButtonState();
      }

    }

    if (!row.Oid) {
      splice();
      return;
    }

    this.workOrderService
      .deleteRow(row)
      .then(obs => obs?.subscribe(() => splice()))

  }

  /**
   * Setup iniziale del componente con caricamento configurazione override
   * Gestisce la configurazione delle colonne visibili e del footer totale
   * 
   * @param model Modello CTWorkOrder con le righe da visualizzare
   */
  async setup(model: CTWorkOrder<CtWorkOrderInformationContent> | null) {

    if (!model) return;

    this.items = model.Rows ?? [];

    // Recupero configurazione override per la tabella righe ordine
    await this.managerService.getComponentOverride("workOrder", "colsWorkOrderRowsConfiguration", this.colsWorkOrderRowsConfiguration).then((component) => {
    });

    // Gestione visibilità colonne tramite configurazione override
    // Se è specificato un array cols nell'override, filtro le colonne in base ad esso
    // Altrimenti uso le colonne di default (tutte tranne Discount)
    if(this.colsWorkOrderRowsConfiguration.cols && this.colsWorkOrderRowsConfiguration.cols.length > 0) {
      // Uso configurazione override
      const allowedFields = this.colsWorkOrderRowsConfiguration.cols;
      this.cols = this.allCols.filter(c => allowedFields.includes(c.field));
    } else {
      // Uso colonne di default (tutte tranne Discount)
      this.cols = this.allCols.filter(c => this.defaultCols.includes(c.field));
    }

    // Gestione flag showTotalRow per il footer con totale complessivo
    // Default: true (footer visibile) se non specificato nell'override
    if (this.colsWorkOrderRowsConfiguration.showTotalRow === undefined || this.colsWorkOrderRowsConfiguration.showTotalRow === null) {
      this.colsWorkOrderRowsConfiguration.showTotalRow = true;
    } else {
    }

    // Gestione flag cloneRowEnabled per abilitare/disabilitare il bottone "Clona riga"
    // Default: false (bottone nascosto) se non specificato nell'override
    if (this.colsWorkOrderRowsConfiguration.cloneRowEnabled === undefined || this.colsWorkOrderRowsConfiguration.cloneRowEnabled === null) {
      this.colsWorkOrderRowsConfiguration.cloneRowEnabled = false;
    } else {
    }

    this.updateCreateButtonState();

  }

  isCol(value : string) : boolean {
    return this.cols.find(c => c.field === value)? true : false
  }

  createOrders() {

    if (!this.configuration?.WorkOrder?.Oid) return;

    const parameter: TransferItemsRequestParameter = TransferItemsRequestParameter
      .create()
      .setWorkOrderOid(this.configuration?.WorkOrder?.Oid)
      .setOrigin(OriginCreateWorkOrderEnum.WorkOrder)
      .setSelectedWorkOrderRowItemOids(this.getSelectedOids())

    this.moduleCreateService
      .open(parameter)
      ?.afterClosed()
      .subscribe(result => {
        if (result) window.location.reload();
      });

  }

  private updateCreateButtonState(): void {
    const hasSelection = this.selectedItems.length > 0;

    this.createButton.setDisabled(!hasSelection);
    this.createButtonTooltip = hasSelection
      ? ""
      : "Selezionare almeno un articolo per generare una movimentazione";
  }

  isNumericColumn(field: string): boolean {
  const numericColumns = ['Quantity', 'Amount', 'Discount', 'VAT'];
  return numericColumns.includes(field);
}
  /**
   * Calcola il totale di una singola riga (Quantità × Prezzo unitario)
   * Questo è il totale PRIMA dell'applicazione dello sconto
   *
   * @param item La riga per cui calcolare il totale
   * @returns Il totale riga senza sconto applicato
   */
  calculateRowTotal(item: CTWorkOrderRowUnionType): number {
    const quantity = item.Quantity ?? 0;
    const amount = item.Amount ?? 0;
    return quantity * amount;
  }

  /**
   * Calcola il totale di una riga DOPO l'applicazione dello sconto
   *
   * @param item La riga per cui calcolare il totale scontato
   * @returns Il totale riga con sconto applicato
   */
  calculateDiscountedTotal(item: CTWorkOrderRowUnionType): number {
    const total = this.calculateRowTotal(item);
    const discount = item.Discount ?? 0;

    if (discount > 0) {
      return total * (1 - discount / 100);
    }

    return total;
  }

  /**
   * Verifica se una riga ha uno sconto applicato
   *
   * @param item La riga da verificare
   * @returns true se c'è uno sconto > 0, false altrimenti
   */
  hasDiscount(item: CTWorkOrderRowUnionType): boolean {
    return (item.Discount ?? 0) > 0;
  }

  /**
   * Calcola il totale complessivo di tutte le righe
   * Somma tutti i totali riga (con sconto applicato)
   *
   * @returns Il totale complessivo dell'ordine/quotazione
   */
  calculateGrandTotal(): number {
    return this.items.reduce((sum, item) => {
      return sum + this.calculateDiscountedTotal(item);
    }, 0);
  }

  /**
   * Tronca una descrizione a maxLength caratteri e aggiunge "..." se necessario
   *
   * @param description La descrizione completa
   * @param maxLength Lunghezza massima (default: 30 caratteri)
   * @returns La descrizione troncata con "..." se supera maxLength
   */
  truncateDescription(description: string | null, maxLength: number = 30): string {
    if (!description) return '';

    if (description.length <= maxLength) {
      return description;
    }

    return description.substring(0, maxLength) + '...';
  }

  /**
   * Verifica se una descrizione è stata troncata (supera i 30 caratteri)
   * Usato per decidere se mostrare il link "clicca per espandere"
   *
   * @param description La descrizione da verificare
   * @returns true se la descrizione supera i 30 caratteri
   */
  isDescriptionTruncated(description: string | null): boolean {
    return (description?.length ?? 0) > 30;
  }

  /**
   * Apre la modale per visualizzare la descrizione completa di un articolo
   * Viene chiamata quando l'utente clicca su una descrizione troncata
   *
   * @param item La riga di cui mostrare la descrizione completa
   */
  openDescriptionDialog(item: CTWorkOrderRowUnionType): void {
    this.dialog.open(MovementManagerDescriptionDialogComponent, {
      width: '600px',
      data: {
        description: item.Description,
        code: item.Code
      }
    });
  }

  protected readonly WorkOrderRowState = WorkOrderRowState;

}
